var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1249 2.29485C14.6628 2.29485 14.213 2.48123 13.8871 2.80711L1.83629 14.8579V20.1637H7.14212L19.1929 8.11294C19.5188 7.78706 19.7052 7.33727 19.7052 6.87513C19.7052 6.41299 19.5188 5.96319 19.1929 5.63731L16.3627 2.80711C16.0368 2.48123 15.587 2.29485 15.1249 2.29485ZM13.2346 2.1546C13.7337 1.65548 14.4183 1.37207 15.1249 1.37207C15.8315 1.37207 16.5161 1.65548 17.0152 2.1546L19.8454 4.98481C20.3445 5.48393 20.628 6.16852 20.628 6.87513C20.628 7.58174 20.3445 8.26632 19.8454 8.76544L7.52435 21.0865H0.913513V14.4757L13.2346 2.1546Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70121 14.3406L7.65954 20.2989L7.00704 20.9514L1.04871 14.9931L1.70121 14.3406Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7012 3.34058L18.6595 9.29891L18.007 9.95141L12.0487 3.99308L12.7012 3.34058Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.1a1a034bd17c9c81d19c077b067dafe6.svg";